@if (entry(); as e) {
  @if (headless) {
    <div class="rail-field-body is-headless">
      @if (hostInjector; as inj) {
        <ng-container *ngComponentOutlet="e.component; injector: inj"></ng-container>
      }
    </div>
  } @else {
  <div class="rail-field" [class.is-open]="open()">
    <div class="rail-field-headrow">
      <button type="button" class="rail-field-head" [attr.aria-expanded]="open()" (click)="toggle()">
        <span class="rf-name" [innerHTML]="nameHtml(e.label)"></span>
        <!-- 2026-06-04 icing #4: summary is now data-aware. Empty state
             ('' or literal 'All') gets the muted+italic .rf-allnone treatment;
             any active value gets .rf-summary (blue, weight 600). The host
             reads the @Input.summary string and routes accordingly. -->
        @if (isEmpty()) {
          <span class="rf-allnone">{{ emptyLabel }}</span>
        } @else {
          <span class="rf-summary">{{ summary }}</span>
        }
      </button>
      <button type="button" class="rf-star" [class.pinned]="pinned" [disabled]="!canPin()"
              (click)="onStarClick()"
              [attr.aria-label]="pinned ? 'Unpin' : 'Pin to top'"
              [title]="canPin() ? (pinned ? 'Unpin' : 'Pin to top') : 'Pinning unavailable for this dimension'">{{ pinned ? '★' : '☆' }}</button>
    </div>
    @if (open()) {
      <div class="rail-field-body">
        @if (hostInjector; as inj) {
          <ng-container *ngComponentOutlet="e.component; injector: inj"></ng-container>
        }
      </div>
    }
  </div>
  }
}
